var map = {
	"./about/head-pic-01.png": "M3LB",
	"./about/head-pic-01@2x.png": "DO2A",
	"./about/head-pic.png": "IHS+",
	"./about/head-pic@2x.png": "47nT",
	"./about/m/head-pic.png": "ekTD",
	"./about/m/head-pic@2x.png": "eGjY",
	"./about/m/pic-01.png": "paCF",
	"./about/m/pic-01@2x.png": "LW1D",
	"./about/m/pic-02.png": "Z3oC",
	"./about/m/pic-02@2x.png": "awGH",
	"./about/m/pic-03.png": "vTv7",
	"./about/m/pic-03@2x.png": "DgEf",
	"./about/m/pic-04.png": "BgiE",
	"./about/m/pic-04@2x.png": "mfWr",
	"./about/pic-01.png": "5+GW",
	"./about/pic-01@2x.png": "AaAd",
	"./about/pic-02.png": "uEbN",
	"./about/pic-02@2x.png": "zKOH",
	"./about/pic-03.png": "RTXE",
	"./about/pic-03@2x.png": "3SEp",
	"./about/pic-04.png": "WrAD",
	"./about/pic-04@2x.png": "dWG8",
	"./arrow.png": "qNF3",
	"./bearish.png": "dgx8",
	"./bullish.png": "vm9q",
	"./commons/accessData.png": "61PB",
	"./commons/data-empty.png": "mw7i",
	"./commons/footer/certification.png": "qNZ7",
	"./commons/footer/certification@2x.png": "0+am",
	"./commons/footer/chengxinwangzhan.png": "1/Qc",
	"./commons/footer/chengxinwangzhan@2x.png": "ahqO",
	"./commons/footer/kexinwangzhan.png": "Uq1x",
	"./commons/footer/kexinwangzhan@2x.png": "gBM3",
	"./commons/footer/renzhenglianmeng.png": "feRo",
	"./commons/footer/renzhenglianmeng@2x.png": "wTUH",
	"./commons/footer/tencent.png": "sK0k",
	"./commons/footer/tencent@2x.png": "UxDv",
	"./commons/footer/time-weekly.png": "4AC6",
	"./commons/footer/time-weekly@2x.png": "v571",
	"./commons/footer/zhongjin.png": "zjmM",
	"./commons/footer/zhongjin@2x.png": "QqS3",
	"./commons/header/logo.png": "7+0T",
	"./commons/header/logo@2x.png": "Z2Ax",
	"./commons/money-active.png": "DS8b",
	"./commons/money-active@2x.png": "ZaBU",
	"./commons/money-important.png": "ck8E",
	"./commons/money-important@2x.png": "Axr/",
	"./commons/money.png": "9hpj",
	"./commons/money@2x.png": "StUP",
	"./commons/star-active.png": "meVE",
	"./commons/star-active@2x.png": "BEao",
	"./commons/star-important.png": "NSa5",
	"./commons/star-important@2x.png": "pZ43",
	"./commons/star.png": "NA1v",
	"./commons/star@2x.png": "GBdf",
	"./icon-1.png": "4R6w",
	"./icon-2.png": "ZQHk",
	"./icon-3.png": "9eTL",
	"./icon-4.png": "ufEw",
	"./icon-calendar.png": "WfM0",
	"./icon-rate.png": "v2os",
	"./icon-sm.png": "VwCb",
	"./notice-icon-2.png": "HKpY",
	"./notice-icon.png": "nLeL",
	"./remark-content.png": "Ycs1",
	"./remark-data.png": "eANS",
	"./remark-image-text.png": "poFz",
	"./remark-link.png": "ZY5R",
	"./remark-market.png": "+yxU",
	"./remark-video.png": "dpXS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.png$
// module id = zfj7
// module chunks = 1